import { scholarshipActionTypes } from 'src/store/actions';

const initialState = {};

const ViewNonScholarshipsReducer = (state = initialState, action) => {
  const { type, payload } = action || {};
  switch (type) {
    case scholarshipActionTypes.GET_STUDENT_NON_SCHOLARSHIP_LIST:
      return { ...state, ...payload };
    default:
      return state;
  }
};

export default ViewNonScholarshipsReducer;
